<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import { ClerkLoaded, ClerkLoading } from '@clerk/vue'
import { Toaster } from '@/components/ui/sonner'
import { isAuthMocked } from '@/lib/env'

const clerkTimedOut = ref(false)
let timer: ReturnType<typeof setTimeout> | undefined

onMounted(() => {
  if (isAuthMocked) return
  timer = setTimeout(() => {
    if (!window.Clerk?.loaded) clerkTimedOut.value = true
  }, 10_000)
})

onUnmounted(() => { clearTimeout(timer) })
</script>

<template>
  <Toaster />
  <template v-if="clerkTimedOut">
    <RouterView />
  </template>
  <template v-else>
    <ClerkLoading>
      <div class="flex h-screen items-center justify-center">
        <div class="size-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    </ClerkLoading>
    <ClerkLoaded>
      <RouterView />
    </ClerkLoaded>
  </template>
</template>
